import { useMutation, type UseMutationOptions, useQuery, useQueryClient } from '@tanstack/react-query';

import { getNodeGrants, GrantsApiKeysEnum, setNodeGrants } from '~services/api/calls/content-access';
import { ApiErrorDescriptor } from '~services/api/helpers';

export const useNodeGrants = (nodeId: string, options?: UseQueryOptionsBase<MenuLinkGrantsDto, ApiErrorDescriptor>) =>
  useQuery({
    queryKey: [GrantsApiKeysEnum.GetNodeGrants, nodeId],
    queryFn: async () => await getNodeGrants(nodeId),
    ...options,
  });

export const useSetNodeGrants = (
  options?: UseMutationOptions<
    boolean,
    ApiErrorDescriptor,
    {
      nodeId: string;
      grants: UpdateMenuLinkGrantsDto;
    }
  >,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: setNodeGrants,
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({ queryKey: [GrantsApiKeysEnum.GetNodeGrants, variables.nodeId] });
      if (options.onSuccess) {
        void options.onSuccess(data, variables, context);
      }
    },
  });
};
